import { createRoot } from 'react-dom/client'
import { QRScannerClient } from '@/components/QRScannerClient';
import '@/styles/global.css'
import { AppStateProvider } from './contexts/AppStateProvider';
import { ThemeProvider } from './contexts/ThemeProvider';
import { StyleProvider } from './contexts/StyleProvider';
import { Container } from './components/Benchmarking/Container';
import { BenchmarkProvider } from './contexts/BenchmarkProvider';
// import { DEFAULT_THEME } from './styles/branding';

createRoot(document.getElementById('root')!).render(
  <BenchmarkProvider>
    <ThemeProvider theme={{}}>
      <AppStateProvider>
        <StyleProvider>
          <Container>
            <QRScannerClient />
          </Container>
        </StyleProvider>
      </AppStateProvider>
    </ThemeProvider>
  </BenchmarkProvider>
)
